<mat-dialog-content class="dispute-dialog-content">
  <h3>{{ patient | patientHeading:'Create Estimate/Invoice (Beta)' }}</h3>
  <div class="dispute-details-container">
    <div class="loading-overlay" *ngIf="isLoading">
      <mat-progress-spinner mode="indeterminate" diameter="64"></mat-progress-spinner>
      <div class="loading-text">Saving, please wait…</div>
    </div>
    <form [formGroup]="form">
      <!-- Billing Information Section -->
      <div class="section-header">
        <div class="section-title">
          <button mat-icon-button (click)="toggleSection('billingInfo')" tabindex="-1">
            <mat-icon>{{ sections.billingInfo ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <h3>Billing Information</h3>
        </div>
        <mat-icon class="help-icon"
          matTooltip="Select the type of billing document and associated appointment details. For quotes, the status will automatically be set to 'Pending'. You can also set the issue date and payment due date.">help_outline</mat-icon>
      </div>
      <div class="section-content" [class.expanded]="sections.billingInfo">
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Type</mat-label>
            <mat-select formControlName="type">
              <mat-option value="Estimate">Estimate</mat-option>
              <mat-option value="Invoice">Invoice</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Appointment Date</mat-label>
            <mat-select formControlName="appointment">
              <mat-option [value]="{}">No Appointment</mat-option>
              <mat-option *ngFor="let appointment of appointments" [value]="appointment">
                {{ appointment.formattedDate }} - {{appointment.appointmentType}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" [disabled]="isQuote()">
              <mat-option value="Pending">Pending</mat-option>
              <mat-option value="Paid">Paid</mat-option>
              <mat-option value="Partially Paid">Partially Paid</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Provider</mat-label>
            <mat-select formControlName="provider">
              <mat-option *ngFor="let provider of groupUsers" [value]="provider.userId">
                {{provider.title}} {{provider.name}} {{provider.surname}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Issue Date</mat-label>
            <input matInput [matDatepicker]="issueDatePicker" formControlName="issueDate">
            <mat-datepicker-toggle matSuffix [for]="issueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #issueDatePicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Due Date</mat-label>
            <input matInput [matDatepicker]="dueDatePicker" formControlName="dueDate">
            <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #dueDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <!-- Billing Details Section -->
      <div class="section-header">
        <div class="section-title">
          <button mat-icon-button (click)="toggleSection('billingDetails')">
            <mat-icon>{{ sections.billingDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <h3>Tariff Details</h3>
        </div>
        <mat-icon class="help-icon"
          matTooltip="Select the appropriate practice tariff rate and add any applicable discounts or notes.">help_outline</mat-icon>
      </div>
      <div class="section-content" [class.expanded]="sections.billingDetails">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Practice Tariff Rate</mat-label>
            <mat-select formControlName="priceGroup" (selectionChange)="onTariffChange($event)">
              <mat-option *ngFor="let tariff of tariffRates" [value]="tariff.id">
                {{tariff.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width" *ngIf="!isPhysioPractice">
            <mat-label>Modifer Type</mat-label>
            <mat-select formControlName="modifierType">
              <mat-option value="practice">Practice Rates</mat-option>
              <mat-option value="pmb">PMB Rates</mat-option>
            </mat-select>
          </mat-form-field>

          <ng-container *ngIf="isPhysioPractice">

            <mat-form-field appearance="outline" class="fill">
              <mat-label>Start Time</mat-label>
              <input matInput formControlName="startTime" [ngxTimepicker]="startTimePicker" [format]="24">
              <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
                [preventOverlayClick]="false"></ngx-material-timepicker>
            </mat-form-field>


            <mat-form-field appearance="outline" class="fill">
              <mat-label>Finish Time</mat-label>
              <input matInput formControlName="finishTime" [ngxTimepicker]="finishTimePicker" [format]="24">
              <ngx-material-timepicker #finishTimePicker [theme]="darkTheme" [appendToInput]="true"
                [preventOverlayClick]="false"></ngx-material-timepicker>
            </mat-form-field>

          </ng-container>

          <mat-form-field appearance="outline" class="small-field">
            <mat-label>Global Discount</mat-label>
            <span matPrefix class="p-l-5 p-r-5" *ngIf="form.get('discountType')?.value !== 'percentage'">R</span>
            <input matInput type="number" formControlName="discount" (keyup)="updateDiscount()" step="0.01" min="0">
            <button matTooltip="Toggle discount type" mat-icon-button matSuffix (click)="toggleDiscountType()"
              type="button">
              <mat-icon>{{ form.get('discountType')?.value === 'percentage' ? 'percent' : 'attach_money' }}</mat-icon>
            </button>
          </mat-form-field>


        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Rule Type</mat-label>
            <mat-select formControlName="ruleType" (selectionChange)="onRuleTypeChange()">
              <mat-option value="OH">Out of Hospital</mat-option>
              <mat-option value="IH">In Hospital</mat-option>
              <mat-option value="DC">Day Clinic</mat-option>
              <mat-option value="SCOPE_OH">Scope Out of Hospital</mat-option>
              <mat-option value="SCOPE_IH">Scope In Hospital</mat-option>
              <mat-option value="SCOPE_DC">Scope Day Clinic</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width"
            *ngIf="form.get('ruleType')?.value.indexOf('IH') > -1">
            <mat-label>Hospital</mat-label>
            <mat-select formControlName="hospital">
              <mat-option *ngFor="let hospital of hospitals" [value]="hospital">
                {{hospital.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Notes</mat-label>
            <textarea matInput rows="1" formControlName="notes"></textarea>
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-checkbox formControlName="vatExclusive"
            matTooltip="Tick this for schemes like WCA. The PDF removes the per-line VAT column and shows totals as Subtotal (excl.) / VAT / Total Due.">
            Display prices VAT exclusive (e.g. WCA)
          </mat-checkbox>
        </div>
      </div>

      <!-- Line Items Section -->
      <div class=" section-header">
        <div class="section-title">
          <button mat-icon-button (click)="toggleSection('lineItems')">
            <mat-icon>{{ sections.lineItems ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
          <h3>{{form.get('type')?.value}} Items</h3>
        </div>
        <mat-icon class="help-icon"
          matTooltip="Add procedure codes, medications, and other billable items. You can search for codes or select from coding bundles. Each item can be expanded to add ICD-10 codes and specific discounts.">help_outline</mat-icon>
      </div>
      <div class="section-content" [class.expanded]="sections.lineItems">
        <app-multiline-items [parentForm]="form" [priceGroup]="form.get('priceGroup')?.value"
          [issueDate]="form.get('issueDate')?.value" [ruleType]="form.get('ruleType')?.value"
          [isPMB]="form.get('modifierType')?.value === 'pmb'" [selectedAppointment]="form.get('appointment')?.value"
          [isPhysioPractice]="isPhysioPractice" [multilineItemsTrigger]="multilineItemsTrigger"
          [providers]="groupUsers" [providerId]="form.get('provider')?.value" (updateTotals)="updateTotals($event)">
        </app-multiline-items>
      </div>

      <!-- Financial Summary Section -->
      <ng-container *ngIf="form.get('lineItems')?.value?.length > 0">
        <div class="section-header">
          <div class="section-title">
            <button mat-icon-button (click)="toggleSection('summary')">
              <mat-icon>{{ sections.summary ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
            <h3>Financial Summary</h3>
          </div>
          <mat-icon class="help-icon"
            matTooltip="Review the total amounts including patient shortfall (difference between medical scheme rate and practice rate), VAT, and final amount due.">help_outline</mat-icon>
        </div>
        <div class="section-content" [class.expanded]="sections.summary">
          <table class="summary-table">
            <tr>
              <th *ngIf="overallVatRate > 0">Subtotal</th>
              <th>Patient Shortfall</th>
              <th *ngIf="overallVatRate > 0">VAT</th>
              <th>Total Due</th>
            </tr>
            <tr>
              <td *ngIf="overallVatRate > 0">R {{ overallSubtotal | number: '1.2-2' }}</td>
              <td>R {{ overallShortfall | number: '1.2-2' }}</td>
              <td *ngIf="overallVatRate > 0">R {{ overallVat | number: '1.2-2' }}</td>
              <td>R {{ overallTotalDue | number: '1.2-2' }}</td>
            </tr>
          </table>
        </div>
      </ng-container>
    </form>
  </div>
</mat-dialog-content>
<div class="formButtons form-row">
  <!-- <div class="payment-info" *ngIf="!isQuote() && form.get('status')?.value === 'Paid'">
    <mat-icon class="info-icon">info</mat-icon>
    <span>Payment capture will automatically open after saving the invoice.</span>
  </div>
  <div class="payment-info" *ngIf="!isQuote() && form.get('status')?.value === 'Partially Paid'">
    <mat-icon class="info-icon">info</mat-icon>
    <span>Partial payment capture will automatically open after saving the invoice.</span>
  </div>-->
  <div class="full-width"></div>
  <mat-dialog-actions align="end">
    <button mat-button (click)="closeDialog()" [disabled]="isLoading">Cancel</button>
    <button mat-button color="accent" [disabled]="isLoading || form.invalid || form.get('lineItems')?.value?.length === 0"
      (click)="previewForm()" *ngIf="form.get('lineItems')?.value?.length > 0">Preview</button>
    <button mat-button color="primary" [disabled]="isLoading || form.invalid || form.get('lineItems')?.value?.length === 0"
      (click)="saveForm()" *ngIf="form.get('lineItems')?.value?.length > 0">Save</button>
  </mat-dialog-actions>
</div>